var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatMute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.841 19.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.841 -19.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.311 6.075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.018,204.271l1.544-1.544a.469.469,0,1,0-.663-.663l-1.544,1.544-1.544-1.544a.469.469,0,1,0-.663.663l1.544,1.544-1.544,1.544a.469.469,0,1,0,.663.663l1.544-1.544,1.544,1.544a.469.469,0,1,0,.663-.663Z",
    transform: "translate(-362.011 -201.927)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.447.147a1.487,1.487,0,0,0-1.594.205l-6.539,3.5H1.5A1.5,1.5,0,0,0,0,5.35v6.308a1.5,1.5,0,0,0,1.5,1.494H4.313l6.539,3.5a1.5,1.5,0,0,0,2.457-1.148V1.5A1.48,1.48,0,0,0,12.447.147ZM3.995,12.162H1.5a.5.5,0,0,1-.5-.5V5.35a.5.5,0,0,1,.5-.5h2.5v7.311Zm8.316,3.345a.5.5,0,0,1-.819.383l-6.5-3.469V4.587l6.5-3.469a.5.5,0,0,1,.819.383Z",
    transform: "translate(0 -0.004)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMute);
export default __webpack_public_path__ + "static/media/chatMute.f46747c3afead3173477fa51f4c8517f.svg";
export { ForwardRef as ReactComponent };